import handleRelianceIPAOnBlueHelper from "./relianceIPAHelper/handleRelianceIPAOnBlueHelper";
import { validateRelianceIPAHelper } from "./relianceIPAHelper/validateRelianceIPAHelper";

export const handleChangeHelper = (
  event,
  productName,
  arrayIndex,
  formik
) => {};

export const handleOnBlurHelper = (event, productName, arrayIndex, formik) => {
  // console.log("productName: ", productName);
  if (productName === "Reliance IPA") {
    handleRelianceIPAOnBlueHelper(event, arrayIndex, formik);
  }
};

export const validateHelper = (value, field, formik) => {
  const { productName } = field;
  if (productName === "Reliance IPA") {
    return validateRelianceIPAHelper(value, field, formik);
  }

  return null;
};
